<template>
  <div
    class="newHome-picture"
    :clstag="'jr|keycount|8530052_index_content|'+item.activityId"
  >
    <router-link
      :to="{ path: 'activity', query: { activityId : item.activityId }}"
      class="J_ping pictureimgSizeStyle"
    >
      <p class="picture-title">{{item.title}}</p>
      <p class="picture-subTitle">{{item.subTitle}}</p>
      <div class="pictureimgWrap"><img
          v-lazy="item.imageUrl"
          alt=""
          class="pictureimg"
        /></div>
      <!-- <div class="picture-float-wrap">
        <p class="pictureTop ellipsis">
          <span class="pictureMarginCom"></span>
          <span></span>
        </p>
      </div> -->
    </router-link>
  </div>
</template>
<script>
export default {
  name: 'PictureFloatingLayer',
  props: {
    item: {
      type: Object,
      default: () => {
        return {
          activityId: '',
          imageUrl: '',
          title: '',
          subTitle: ''
        };
      }
    },
    imgSize: {
      type: String,
      default: () => {
        return 'PictureimgSizeStyle';
      }
    }
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import './../scss/mixin.scss';
.pictureimgSizeStyle {
  width: 100%;
  // height: $rem440;
  position: relative;
  display: block;
  overflow: hidden;
}

.newHome-picture {
  font-family: PingFangSC-Medium;
  background: #ffffff;
  padding: $rem32 $rem32 0 $rem32;
  .picture-title {
    font-size: $rem40;
    color: #333333;
    font-weight: 500;
    line-height: $rem48;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
  .picture-subTitle {
    font-size: $rem26;
    color: #333333;
    line-height: $rem32;
    padding-bottom: $rem32;
    padding-top: $rem8;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    font-family: PingFangSC-Regular;
  }
}
.pictureimgWrap {
  width: 100%;
  min-height: 168.95px;
  overflow: hidden;
}
.pictureimg {
  width: 100%;
  overflow: hidden;
}

.picture-float-wrap {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: $rem160;
  // background: rgba(0, 0, 0, 0.2);
  color: #fff;
  font-family: PingFangSC-Regular;
  padding-left: $rem40;
  padding-right: $rem40;
  // opacity: 0.5;
  background: linear-gradient(-180deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.pictureTop {
  font-size: $rem36;
  color: #ffffff;
  // margin-top: $rem32;
  line-height: $rem50;
  margin-bottom: $rem8;
  text-align: left;
}
.pictureBottom {
  opacity: 0.8;
  font-size: $rem24;
  line-height: $rem33;
  margin-bottom: $rem32;
}
.pictureMarginCom {
  margin-left: $rem20;
  margin-right: $rem20;
}
</style>
